import { List } from 'immutable'
import { get } from 'lodash'
import { DetectedField } from './DetectedField'

export default class ModelObject {
    get(name: string): DetectedField | List<DetectedField> | ModelObject | null {
        return get(this, name, null)
    }
}